const actions = {
  open: 'open',
  close: 'close',
  active: 'active',
  refresh: 'refresh',
  sort: 'sort',
};
export default actions;
